 
import React from 'react';

const ArrowDown: React.FC<object> = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g opacity="0.5">
                <path d="M3.96875 6.03027L7.96901 10.0306" stroke="#899696" strokeWidth="2" strokeLinecap="round"/>
                <path d="M12.0308 6.02983L8.03258 10.0289" stroke="#899696" strokeWidth="2" strokeLinecap="round"/>
            </g>
        </svg>

    );
};

export default ArrowDown;